export default __webpack_public_path__ + "static/media/foundation.52b344f2.png";